import {Fragment} from "react";
import {Center, Spinner} from "@chakra-ui/react";
import {usePricingContext} from "../context/pricingContext/context";

const WaitForPricingData = (props) => {
  const {children} = props;
  const {loading} = usePricingContext();
  return (
    <Fragment>
      {loading ? (
        <Center h={"300px"}>
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      ) : (
        children
      )}
    </Fragment>
  );
};

export default WaitForPricingData;
